module.exports = __webpack_public_path__ + "static/img/default-avatar.22f4ad3e.png";